import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActiveTeamService {

  private activeTeamIndexSource = new BehaviorSubject<number | null>(null);
  activeTeamIndex$ = this.activeTeamIndexSource.asObservable();

  setActiveTeamIndex(index: number | null) {
    this.activeTeamIndexSource.next(index);
  }

  getActiveTeamIndex(): number | null {
    return this.activeTeamIndexSource.value;
  }
}
